// src/viewport.js（不使用 Optional Chaining）
export const setViewport = () => {
  const designWidth = 1200;
  const scale = Math.min(window.innerWidth / designWidth, 1);
  
  // 替换 ?. 为传统的条件判断
  const existingMeta = document.querySelector('meta[name="viewport"]');
  if (existingMeta) {
    existingMeta.remove();
  }
  
  const meta = document.createElement('meta');
  meta.name = 'viewport';
  meta.content = `width=${designWidth}, initial-scale=${scale}, maximum-scale=${scale}, minimum-scale=${scale}, user-scalable=no`;
  
  document.head.appendChild(meta);
};

// 初始化并监听窗口变化
setViewport();
window.addEventListener('resize', setViewport);